module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('breadcrumb-bar', {
    attrs: {
      "crumbs": [{
        name: 'Administrative Settings'
      }, {
        name: 'General Settings',
        link: 'General Settings'
      }]
    }
  }), _vm._v(" "), (_vm.generalSettingsLoading) ? _c('vue-spinner') : [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('maintenance-mode', {
    attrs: {
      "status": _vm.generalSettings.maintenance_mode,
      "message": _vm.generalSettings.maintenance_message
    }
  })], 1)])]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01f4af56","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/GeneralSettings.vue
// module id = 1536
// module chunks = 1